(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mavisse-header-account"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mavisse-header-account')) {
  customElements.define('mavisse-header-account', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const details = this.querySelector('details');
      document.addEventListener('click', (event) => {
        if (details.open && !this.contains(event.target)) details.open = false;
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          details.open = false;
          this.querySelector('summary').focus();
          event.stopPropagation();
        }
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mavisse-privacy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const button = event.target.closest('[data-mv-privacy-settings]');
  if (!button) return;
  const settings = document.querySelector('[data-cookie-settings]');
  if (settings) settings.click();
  else document.querySelectorAll('[data-mv-privacy-fallback]').forEach(message => { message.hidden = false; });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mavisse-wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.mvWishlistReady) return;
  const dialog = document.getElementById('mv-wishlist');
  if (!dialog) return;
  window.mvWishlistReady = true;
  const key = 'mavisse.wishlist.v1';
  const grid = dialog.querySelector('[data-mv-wish-grid]');
  const status = document.querySelector('[data-mv-wish-status]');
  let items = [], persistent = true, opener;
  const safeUrl = (value, image = false) => {
    try {
      const url = new URL(value, location.origin);
      return ['https:', 'http:'].includes(url.protocol) && (image || url.origin === location.origin) ? url.href : '';
    } catch { return ''; }
  };
  const read = () => {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      items = Array.isArray(data) ? data.filter(x => x && typeof x.id === 'string' && typeof x.title === 'string' && safeUrl(x.url)).slice(0,500) : [];
    } catch { items = []; }
  };
  read();
  const sync = (root = document) => {
    root.querySelectorAll('[data-mv-wish-toggle]').forEach(button => {
      const saved = items.some(x => x.id === button.dataset.id);
      const label = saved ? dialog.dataset.remove : dialog.dataset.add;
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', label + ': ' + button.dataset.title);
      const text = button.querySelector('[data-mv-wish-label]');
      if (text && text.textContent !== label) text.textContent = label;
    });
    document.querySelectorAll('[data-mv-wish-count]').forEach(count => {
      count.textContent = String(items.length);
      count.hidden = !items.length;
    });
  };
  const render = () => {
    grid.replaceChildren();
    dialog.querySelector('[data-mv-wish-empty]').hidden = items.length > 0;
    items.forEach(item => {
      const card = document.createElement('article');
      card.className = 'mv-wishlist__card';
      const link = document.createElement('a');
      link.href = safeUrl(item.url);
      if (item.image && safeUrl(item.image, true)) {
        const image = document.createElement('img');
        image.src = safeUrl(item.image, true); image.alt = ''; image.loading = 'lazy'; image.width = 500; image.height = 500;
        link.append(image);
      }
      const title = document.createElement('h3'); title.textContent = item.title;
      const view = document.createElement('span'); view.className = 'mv-wishlist__view'; view.textContent = dialog.dataset.view;
      link.append(title, view);
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'mv-wishlist__remove';
      remove.dataset.mvWishRemove = item.id; remove.textContent = dialog.dataset.remove; remove.setAttribute('aria-label', dialog.dataset.remove + ': ' + item.title);
      card.append(link, remove); grid.append(card);
    });
  };
  const save = () => {
    try { localStorage.setItem(key, JSON.stringify(items)); } catch { persistent = false; }
    if (!persistent) dialog.querySelector('[data-mv-wish-note]').textContent = dialog.dataset.session;
    sync(); if (dialog.open) render();
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-mv-wish-toggle], [data-mv-wish-open], [data-mv-wish-close], [data-mv-wish-remove]');
    if (!button) return;
    event.preventDefault();
    if (button.hasAttribute('data-mv-wish-open')) {
      opener = button; render(); dialog.showModal(); document.documentElement.classList.add('mv-wish-lock'); return;
    }
    if (button.hasAttribute('data-mv-wish-close')) { dialog.close(); return; }
    if (button.hasAttribute('data-mv-wish-remove')) {
      const index = items.findIndex(x => x.id === button.dataset.mvWishRemove);
      items = items.filter(x => x.id !== button.dataset.mvWishRemove); save();
      const remaining = grid.querySelectorAll('[data-mv-wish-remove]');
      (remaining[Math.min(index,remaining.length-1)] || dialog.querySelector('[data-mv-wish-close]')).focus();
      status.textContent = dialog.dataset.removed; return;
    }
    const exists = items.some(x => x.id === button.dataset.id);
    if (exists) items = items.filter(x => x.id !== button.dataset.id);
    else items.push({id:button.dataset.id,title:button.dataset.title,url:button.dataset.url,image:button.dataset.image});
    save(); status.textContent = exists ? dialog.dataset.removed : dialog.dataset.added;
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  dialog.addEventListener('close', () => { document.documentElement.classList.remove('mv-wish-lock'); if (opener?.isConnected) opener.focus(); });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { read(); sync(); if (dialog.open) render(); } });
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-mv-wish-toggle],[data-mv-wish-open]') || node.querySelector('[data-mv-wish-toggle],[data-mv-wish-open]'))))) sync();
  }).observe(document.body, {childList:true,subtree:true});
  sync();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    const mavisseCardGalleries = new WeakMap();
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-mavisse-photo-step]');
  if (!button) return;
  event.preventDefault();
  event.stopPropagation();
  const card = button.closest('product-card');
  const primary = card?.querySelector('.product-card__image--primary');
  if (!primary) return;
  let gallery = mavisseCardGalleries.get(card);
  if (!gallery) {
    const template = card.querySelector('.mavisse-card-gallery-images');
    const candidates = [primary, card.querySelector('.product-card__image--secondary'), ...Array.from(template?.content.querySelectorAll('img') || [])].filter(Boolean);
    const seen = new Set();
    const images = candidates.filter(image => {
      const key = new URL(image.getAttribute('src'), location.href).pathname;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    }).map(image => ({src:image.getAttribute('src'),srcset:image.getAttribute('srcset'),sizes:image.getAttribute('sizes'),alt:image.getAttribute('alt') || primary.alt}));
    const secondary = card.querySelector('.product-card__image--secondary');
    const secondaryStyle = secondary && getComputedStyle(secondary);
    const visibleImage = secondaryStyle && secondaryStyle.display !== 'none' && secondaryStyle.visibility !== 'hidden' && Number(secondaryStyle.opacity) > 0 ? secondary : primary;
    const visiblePath = new URL(visibleImage.getAttribute('src'), location.href).pathname;
    const visibleIndex = images.findIndex(image => new URL(image.src, location.href).pathname === visiblePath);
    gallery = { images, index: Math.max(0, visibleIndex) };
    mavisseCardGalleries.set(card, gallery);
  }
  gallery.index = (gallery.index + Number(button.dataset.mavissePhotoStep) + gallery.images.length) % gallery.images.length;
  const image = gallery.images[gallery.index];
  for (const attribute of ['src','srcset','sizes','alt']) {
    if (image[attribute] !== null) primary.setAttribute(attribute,image[attribute]);
    else primary.removeAttribute(attribute);
  }
  card.setAttribute('data-mavisse-gallery-active','');
}, true);
  } catch(e) { console.error(e); }
})();

})();
